import React from "react";
import { observer } from "mobx-react-lite";
import { ComboBoxContext, ComboBoxState } from "./ComboBox.context";
import { ComboBoxComponent, IComboBoxProps } from "./ComboBox.component";

export const ComboBox: React.FC<IComboBoxProps> = observer((props) => {
  const [state] = React.useState(new ComboBoxState(props));
  return (
    <ComboBoxContext.Provider value={state}>
      <ComboBoxComponent label={props.label} />
    </ComboBoxContext.Provider>
  );
});

export type { IComboBoxOption } from "./ComboBox.context";
export type { IComboBoxProps } from "./ComboBox.component";
